import axios from "axios";

const API = axios.create({
});

API.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error.response.status === 401) {
        console.log('expire session, logging out ...');
        alert("操作超時，請再次登錄。\nThe session is expired. Please log in again.");
		location.reload();
    } else {
    	alert("伺務器錯誤，請稍後再試。\nServer error. Please try again later.");
    }
    
    return Promise.reject(error.response);
});

export default API;